import axios from 'axios'

const PLACE_ID =
  process.env.REACT_APP_GOOGLE_PLACE_ID || 'ChIJoR2SeG5dtokRlWJo3euCGh4'
const API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCNHEa4WLAJvgzoZptLJETQePYSmM8FhTY'

// Live Cloud Function (already deployed on sarahadombraidingsalon).
const PRODUCTION_REVIEWS_URL =
  process.env.REACT_APP_REVIEWS_API_URL ||
  'https://us-central1-sarahadombraidingsalon.cloudfunctions.net/sarah/fetchGoogleData'

export async function fetchGoogleReviews() {
  const params = {
    place_id: PLACE_ID,
    fields: 'rating,reviews',
    reviews_sort: 'newest',
  }

  let response

  if (process.env.NODE_ENV === 'development') {
    // CRA dev proxy → maps.googleapis.com/maps/api/place
    response = await axios.get('/details/json', {
      params: { ...params, key: API_KEY },
    })
  } else {
    // Production: use deployed Cloud Function (hosting does not proxy this path).
    response = await axios.get(PRODUCTION_REVIEWS_URL, { params })
  }

  const payload = response?.data

  if (!payload || payload.status !== 'OK') {
    throw new Error(payload?.error_message || payload?.status || 'Google Places API error')
  }

  const result = payload.result || {}
  const reviews = Array.isArray(result.reviews) ? result.reviews : []

  return {
    rating: result.rating || '',
    reviews: [...reviews].sort((a, b) => (Number(b.time) || 0) - (Number(a.time) || 0)),
  }
}
